import React, { useEffect, useState } from "react";

import {
  CBadge,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CTooltip
} from "@coreui/react";
import { RiAwardFill } from "react-icons/ri";
import { useSelector } from "react-redux";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import { hasGameficandusModule } from "../../../utils/accessSession";

const XpBadge = () => {
  const token = useSelector(state => state.user.token);
  const roleType = useSelector(state => state.general.active_roles?.type);
  const userModules = useSelector(state => state.user?.user_modules);
  const hasXpModule = hasGameficandusModule(userModules);
  const [xp, setXp] = useState(null);

  useEffect(() => {
    if (roleType !== "A" || !token || !hasXpModule) {
      setXp(null);
      return;
    }

    axios
      .get(`${URL.api}xp/me`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resp => {
        if (resp.status === 200 && resp.data.success) {
          setXp(resp.data.data);
        }
      })
      .catch(() => {});
  }, [roleType, token, hasXpModule]);

  if (!xp) {
    return null;
  }

  const progressPercent =
    xp.xp_para_proximo_nivel && xp.xp_para_proximo_nivel > 0
      ? Math.min(
          100,
          Math.round((xp.xp_no_nivel_atual / xp.xp_para_proximo_nivel) * 100)
        )
      : 100;

  return (
    <CTooltip content="Nível e XP">
      <CDropdown inNav className="c-header-nav-item mx-2">
        <CDropdownToggle
          className="c-header-nav-link"
          caret={false}
          // Âncora do tour do aluno (components/Tour/roteiros/aluno.js). Não há
          // classe que distinga este badge: ele e o de ofensiva são CDropdown com
          // `c-header-nav-item`, igual a notificações e avatar.
          data-tour="nivel-xp"
        >
          <RiAwardFill className="header-icon" />
          <CBadge shape="pill" color="success">
            Nv. {xp.level}
          </CBadge>
          <div
            className="rounded mt-1 mx-auto"
            style={{ width: 44, height: 4, backgroundColor: "#e4e7ea" }}
          >
            <div
              className="rounded"
              style={{
                width: `${progressPercent}%`,
                height: 4,
                backgroundColor: "#2eb85c"
              }}
            />
          </div>
        </CDropdownToggle>
        <CDropdownMenu
          placement="bottom-end"
          className="pt-0"
          style={{ minWidth: 260 }}
        >
          <CDropdownItem
            header
            tag="div"
            color="light"
            className="border-0 d-flex justify-content-center"
          >
            <strong>Nível {xp.level}</strong>
          </CDropdownItem>
          <div className="px-3 py-2">
            <div className="text-center mb-2">
              {xp.xp_para_proximo_nivel
                ? `${xp.xp_no_nivel_atual} / ${xp.xp_para_proximo_nivel} XP`
                : `${xp.xp} XP (nível máximo)`}
            </div>
            <div
              className="rounded"
              style={{ width: "100%", height: 8, backgroundColor: "#e4e7ea" }}
            >
              <div
                className="rounded"
                style={{
                  width: `${progressPercent}%`,
                  height: 8,
                  backgroundColor: "#2eb85c"
                }}
              />
            </div>
          </div>
        </CDropdownMenu>
      </CDropdown>
    </CTooltip>
  );
};

export default XpBadge;
